import { createAction } from '@reduxjs/toolkit';
import EcomEngineAPI from 'api/ecom_engine_api';
import { alterServices, trackError } from 'utils/helpers';
import { getFindParam } from 'tenants/sealink/ferry_flow/helpers';

const fetchFerryServicesStarted = createAction(
  'reservation/fetchFerryServicesStarted'
);
const fetchFerryServicesSucceeded = createAction(
  'reservation/fetchFerryServicesSucceeded'
);
const fetchFerryServicesFailure = createAction(
  'reservation/fetchFerryServicesFailure'
);
const setFerryServices = createAction('reservation/setFerryServices');

const fetchFerryServices = (segmentId) => (dispatch, getState) => {
  dispatch(fetchFerryServicesStarted({ segmentId }));
  dispatch(setFerryServices({ segmentId, services: [] }));
  const state = getState();
  const groupingValues = state.ui.sealink.ferryGrouping[0].values;
  const params = getFindParam(
    groupingValues,
    state.routes,
    state.sealink,
    segmentId
  );

  return EcomEngineAPI.reservation
    .findServices(params)
    .then((json) => {
      dispatch(fetchFerryServicesSucceeded({ segmentId, json }));
      dispatch(setFerryServices({ segmentId, services: alterServices(json) }));
    })
    .catch((error) => {
      trackError(error);
      dispatch(
        fetchFerryServicesFailure({ segmentId, message: error.message })
      );
    });
};

export {
  fetchFerryServicesStarted,
  fetchFerryServicesSucceeded,
  fetchFerryServicesFailure,
  fetchFerryServices,
  setFerryServices,
};
